/**
 * FamilyNest-Wortmarke (10 – UI/UX / Branding). „Family" in Schiefer, „Nest" in
 * Salbeigrün, optional mit Logo-Mark und Claim. Nutzt die Design-Tokens.
 */
export const TAGLINE = 'Unser Zuhause. Unsere Zeit. Unsere Familie.'

export function Wordmark({ className = '' }: { className?: string }): React.JSX.Element {
  return (
    <span className={`font-semibold tracking-tight ${className}`}>
      <span style={{ color: 'var(--color-ink)' }}>Family</span>
      <span style={{ color: 'var(--color-accent)' }}>Nest</span>
    </span>
  )
}

export function Logo({
  size = 48,
  withTagline = false,
}: {
  size?: number
  withTagline?: boolean
}): React.JSX.Element {
  return (
    <div className="flex items-center gap-3">
      <img src="/icon.png" width={size} height={size} alt="FamilyNest Logo" />
      <div className="leading-tight">
        <Wordmark className="text-2xl" />
        {withTagline && (
          <p className="text-sm" style={{ color: 'var(--color-accent-soft)' }}>
            {TAGLINE}
          </p>
        )}
      </div>
    </div>
  )
}
